/* IBO custom (see theme/CUSTOMIZATIONS.md), 2026-09-29. Phone product page (reports/design/2026-09-29-instacart-mobile-spec.md).
   Loaded by the sections/main-product.liquid stock edit (sticky panel), defer.
   1. Sticky bar stepper (snippets/ibo-pdp-bar.liquid) is a proxy: its value is copied into the main form's quantity, and the
      button label becomes "Add 3 · $23.97" for n > 1. Canopy re-renders the whole panel on a variant change (the stepper
      value is carried over by its id), so the bar is re-synced whenever a new panel is inserted.
   2. The bar button shows Canopy's loading state while the main form adds (the inline button is hidden on phones).
   3. "More details" in the Pantry card opens the "About this product" accordion.
   4. While "Items to add next" is on screen, its products are dropped from "More from the same shelf" and "Recently viewed".
   5. (2026-10-11) Phones: the Shopify Forms signup popup ends above the sticky bar, so it never covers "Add to cart". */
(() => {
  const d = document;
  const phone = window.matchMedia('(max-width: 768.98px)');

  const num = (c, p, t, dc) => {
    const [a, b] = (c / 100).toFixed(p).split('.');
    return a.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (b ? dc + b : '');
  };
  const money = (c, fmt) => (fmt || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => ({
    amount: num(c, 2, ',', '.'),
    amount_no_decimals: num(c, 0, ',', '.'),
    amount_with_comma_separator: num(c, 2, '.', ','),
    amount_no_decimals_with_comma_separator: num(c, 0, '.', ','),
    amount_with_apostrophe_separator: num(c, 2, "'", '.'),
  }[k] || num(c, 2, ',', '.')));

  const formQty = (bar) => {
    const form = d.getElementById(bar.dataset.form);
    return form && form.querySelector('input[name="quantity"]');
  };

  const sync = (bar) => {
    const input = bar.querySelector('.qty-input__input');
    if (!input) return;
    const fq = formQty(bar);
    if (fq && fq.max) input.max = fq.max;
    let q = parseInt(input.value, 10) || 1;
    if (q < 1) q = 1;
    if (input.max && q > Number(input.max)) q = Number(input.max);
    if (String(q) !== input.value) input.value = q;
    if (fq && fq.value !== String(q)) fq.value = q;
    const minus = bar.querySelector('.btn--minus');
    if (minus && !('soldOut' in bar.dataset)) minus.disabled = q <= 1;
    const label = bar.querySelector('[data-ibo-bar-label]');
    const short = bar.querySelector('[data-ibo-bar-short]');
    if (!label || 'soldOut' in bar.dataset) return;
    const price = Number(bar.dataset.price) || 0;
    const multi = (bar.dataset.tAddQty || '').replace('[[qty]]', q).replace('[[total]]', money(price * q, bar.dataset.fmt));
    const text = q > 1 ? multi : (bar.dataset.tAdd || '').replace('[[price]]', money(price, bar.dataset.fmt));
    const textShort = q > 1 ? multi : (bar.dataset.tAddShort || '').replace('[[price]]', money(price, bar.dataset.fmt));
    if (text && label.textContent !== text) label.textContent = text;
    if (short && textShort && short.textContent !== textShort) short.textContent = textShort;
  };
  const syncAll = () => d.querySelectorAll('.ibo-mbar').forEach(sync);

  ['change', 'input'].forEach((type) => d.addEventListener(type, (e) => {
    const bar = e.target.closest && e.target.closest('.ibo-mbar');
    if (bar) sync(bar);
  }));

  // Loading state on the bar button while Canopy's product-form adds the item.
  let loadT;
  const stopLoading = () => {
    clearTimeout(loadT);
    d.querySelectorAll('.ibo-mbar__add.is-loading').forEach((b) => b.classList.remove('is-loading'));
  };
  d.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('.ibo-mbar__add');
    if (btn && !btn.disabled) {
      const bar = btn.closest('.ibo-mbar');
      if (bar) sync(bar);
      btn.classList.add('is-loading');
      clearTimeout(loadT);
      loadT = setTimeout(stopLoading, 4000);
    }
    // Pantry card "More details": open the About accordion (phones; on desktop the link is hidden)
    const more = e.target.closest && e.target.closest('[data-ibo-open-acc]');
    if (more) {
      const acc = d.getElementById(more.dataset.iboOpenAcc);
      if (acc && acc.offsetParent !== null) {
        e.preventDefault();
        acc.open = true;
        acc.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        const sum = acc.querySelector('summary');
        if (sum) sum.focus({ preventScroll: true });
      }
    }
  });
  ['on:cart:add', 'on:line-item:change', 'on:cart:error'].forEach((ev) => d.addEventListener(ev, () => setTimeout(stopLoading, 300)));

  // "Items to add next" ids out of the lower rows (phones, row on screen)
  const addNext = d.querySelector('[data-ibo-addnext-ids]');
  const ids = new Set(addNext ? addNext.dataset.iboAddnextIds.split(',').filter(Boolean) : []);
  const prune = () => {
    if (!ids.size || !phone.matches || !addNext || addNext.offsetParent === null) return;
    d.querySelectorAll('product-recommendations product-card[data-product-id], recently-viewed product-card[data-product-id]').forEach((card) => {
      if (!ids.has(card.dataset.productId)) return;
      const li = card.closest('li');
      (li || card).remove();
    });
  };

  const root = d.getElementById('main-content') || d.body;
  new MutationObserver((muts) => {
    let bar = false;
    let cards = false;
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;
        if (n.matches('sticky-atc-panel, .ibo-mbar') || n.querySelector('.ibo-mbar')) bar = true;
        if (n.matches('product-card') || n.querySelector('product-card')) cards = true;
      }
    }
    if (bar) syncAll();
    if (cards) prune();
  }).observe(root, { childList: true, subtree: true });

  // 5. Shopify Forms signup popup vs the sticky bar (2026-10-11, site audit finding 4). On phones the Forms app makes its
  //    floating popup a full-screen fixed layer (inside <shopify-forms-embed>'s open shadow root, z-index 2147483647), so it
  //    covered the sticky "Add to cart" even outside the popup card. A small stylesheet in that shadow root makes the
  //    app's .appEmbed container the containing block (transform) and ends it at the top of the sticky bar
  //    (bottom: var(--ibo-bar-h), the bar height from ibo.css). The popup card stays centred in the space above the bar;
  //    the bar stays visible and tappable. Only while the container has content (:has(> *)), only < 769 px, only on
  //    product pages (this file loads only there). If Shopify renames .appEmbed / data-layout, the rule simply does nothing.
  //    Fix 2026-10-11 (QA block): the app's own sheet sets `transform: unset !important` on
  //    ._appEmbedRoot_*[data-layout="floating"][data-current-step="form"] (specificity 0,3,0), so a plain transform lost and
  //    the inner fixed <section> still filled the screen. The :is(#ibo-forms-boost, .appEmbed) part lifts this rule to
  //    ID specificity (1,x,x) without needing that ID to exist, and transform now has !important, so it wins.
  //    :has(> :not(style)) = only while the popup has real content (the container always holds a <style>).
  const FORMS_TAG = 'shopify-forms-embed';
  const FORMS_CSS = '@media (max-width: 768.98px) {'
    + ' .appEmbed:is([data-layout="floating"], [data-layout="overlay"]):is(#ibo-forms-boost, .appEmbed):has(> :not(style)) {'
    + ' top: 0 !important; right: 0 !important; bottom: var(--ibo-bar-h, 94px) !important; left: 0 !important;'
    + ' width: auto !important; height: auto !important; padding: 0 !important; transform: translateZ(0) !important; } }';
  const patchForms = (host) => {
    const sr = host.shadowRoot;
    if (!sr || sr.iboBarPatched) return;
    sr.iboBarPatched = true;
    try {
      const sheet = new CSSStyleSheet();
      sheet.replaceSync(FORMS_CSS);
      sr.adoptedStyleSheets = [...sr.adoptedStyleSheets, sheet];
    } catch (e) {
      const st = d.createElement('style');
      st.textContent = FORMS_CSS;
      sr.appendChild(st);
    }
  };
  const scanForms = (n) => {
    if (n.nodeType !== 1) return;
    if (n.localName === FORMS_TAG) patchForms(n);
    else if (n.firstElementChild) Array.from(n.getElementsByTagName(FORMS_TAG)).forEach(patchForms);
  };
  Array.from(d.getElementsByTagName(FORMS_TAG)).forEach(patchForms);
  new MutationObserver((muts) => {
    for (const m of muts) for (const n of m.addedNodes) scanForms(n);
  }).observe(d.documentElement, { childList: true, subtree: true });

  const ready = () => { syncAll(); prune(); };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', ready); else ready();
})();
